import { useEffect } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom'

const NEXT_STEPS = [
  'Ihr Account wurde automatisch erstellt',
  'Ihr Abonnement ist aktiv',
]

export default function CheckoutSuccess() {
  const location = useLocation()
  const navigate = useNavigate()

  const { orderId, email, appName } = location.state || {}

  useEffect(() => {
    // Ohne Bestelldaten zurück zur Übersicht
    if (!orderId || !email) {
      navigate('/apps')
    }
  }, [orderId, email, navigate])

  if (!orderId || !email) {
    return null
  }

  return (
    <div className="wc-container" style={{ padding: '80px 32px' }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        <div className="wc-card wc-elev-sm" style={{ padding: 32, gap: 20 }}>
          <span
            aria-hidden="true"
            style={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              border: '1px solid var(--wc-accent)',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="var(--wc-accent)" strokeWidth="1.8">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </span>

          <h1 style={{ margin: 0 }}>Bestellung erfolgreich!</h1>
          <p style={{ fontSize: 17, opacity: 0.85, margin: 0 }}>
            Vielen Dank für Ihre Bestellung von <strong>{appName}</strong>.
          </p>

          <div className="wc-hr" style={{ margin: '4px 0' }}></div>

          <div>
            <h2 style={{ fontSize: 17, marginBottom: 12 }}>Was passiert als Nächstes?</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[
                ...NEXT_STEPS,
                `Eine Bestätigungs-E-Mail wurde an ${email} gesendet`,
              ].map((step) => (
                <div key={step} style={{ display: 'flex', gap: 10, fontSize: 14 }}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="var(--wc-accent)"
                    strokeWidth="2"
                    style={{ flex: 'none', marginTop: 2 }}
                    aria-hidden="true"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                  <span style={{ opacity: 0.85 }}>{step}</span>
                </div>
              ))}
            </div>
          </div>

          <p className="wc-muted wc-mono" style={{ fontSize: 13, margin: 0 }}>
            Bestellnummer: #{orderId}
          </p>

          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 4 }}>
            <Link to="/login" className="wc-btn wc-btn-primary wc-btn-lg">
              Jetzt anmelden
            </Link>
            <Link to="/apps" className="wc-btn wc-btn-secondary wc-btn-lg">
              Weitere Apps entdecken
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
